import EmberObject from '@ember/object';

export default EmberObject.create({
  orders: [
    /*1st order*/
    { nthOrder: 1, stages: [{ stageQ: 0.5, stageFp: 1, stageFz: 1, stageId: 1, orderType: 1, gain: 1 }] },
    { nthOrder: 2, stages: [{ stageQ: 0.57735, stageFp: 1.732051, stageFz: 1, stageId: 1, orderType: 2, gain: 1 }] },
    {
      nthOrder: 3,
      stages: [
        { stageQ: 0.5, stageFp: 2.322185, stageFz: 1, stageId: 1, orderType: 1, gain: 1 },
        { stageQ: 0.691047, stageFp: 2.541541, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
      ],
    },
    {
      nthOrder: 4,
      stages: [
        { stageQ: 0.521935, stageFp: 3.023265, stageFz: 1, stageId: 1, orderType: 2, gain: 1 },
        { stageQ: 0.805538, stageFp: 3.389366, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
      ],
    },
    {
      nthOrder: 5,
      stages: [
        { stageQ: 0.5, stageFp: 3.646739, stageFz: 1, stageId: 1, orderType: 1, gain: 1 },
        { stageQ: 0.563536, stageFp: 3.777894, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
        { stageQ: 0.916477, stageFp: 4.261023, stageFz: 1, stageId: 3, orderType: 2, gain: 1 },
      ],
    },
    {
      nthOrder: 6,
      stages: [
        { stageQ: 0.510318, stageFp: 4.336027, stageFz: 1, stageId: 1, orderType: 2, gain: 1 },
        { stageQ: 0.611195, stageFp: 4.566489, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
        { stageQ: 1.023314, stageFp: 5.149177, stageFz: 1, stageId: 3, orderType: 2, gain: 1 },
      ],
    },
    {
      nthOrder: 7,
      stages: [
        { stageQ: 0.5, stageFp: 4.971787, stageFz: 1, stageId: 1, orderType: 1, gain: 1 },
        { stageQ: 0.532356, stageFp: 5.066206, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
        { stageQ: 0.660821, stageFp: 5.37927, stageFz: 1, stageId: 3, orderType: 2, gain: 1 },
        { stageQ: 1.126258, stageFp: 6.049528, stageFz: 1, stageId: 4, orderType: 2, gain: 1 },
      ],
    },
    {
      nthOrder: 8,
      stages: [
        { stageQ: 0.505991, stageFp: 5.654841, stageFz: 1, stageId: 1, orderType: 2, gain: 1 },
        { stageQ: 0.559609, stageFp: 5.825353, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
        { stageQ: 0.710852, stageFp: 6.210415, stageFz: 1, stageId: 3, orderType: 2, gain: 1 },
        { stageQ: 1.225669, stageFp: 6.959311, stageFz: 1, stageId: 4, orderType: 2, gain: 1 },
      ],
    },
    {
      nthOrder: 9,
      stages: [
        { stageQ: 0.5, stageFp: 6.297019, stageFz: 1, stageId: 1, orderType: 1, gain: 1 },
        { stageQ: 0.519709, stageFp: 6.370971, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
        { stageQ: 0.589406, stageFp: 6.606561, stageFz: 1, stageId: 3, orderType: 2, gain: 1 },
        { stageQ: 0.760611, stageFp: 7.056097, stageFz: 1, stageId: 4, orderType: 2, gain: 1 },
        { stageQ: 1.321912, stageFp: 7.876639, stageFz: 1, stageId: 5, orderType: 2, gain: 1 },
      ],
    },
    {
      nthOrder: 10,
      stages: [
        { stageQ: 0.503913, stageFp: 6.976213, stageFz: 1, stageId: 1, orderType: 2, gain: 1 },
        { stageQ: 0.537552, stageFp: 7.112128, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
        { stageQ: 0.62047, stageFp: 7.405346, stageFz: 1, stageId: 3, orderType: 2, gain: 1 },
        { stageQ: 0.809791, stageFp: 7.913633, stageFz: 1, stageId: 4, orderType: 2, gain: 1 },
        { stageQ: 1.415309, stageFp: 8.800154, stageFz: 1, stageId: 5, orderType: 2, gain: 1 },
      ],
    },
    {
      nthOrder: 11,
      stages: [
        { stageQ: 0.5, stageFp: 7.62234, stageFz: 1, stageId: 1, orderType: 1, gain: 1 },
        { stageQ: 0.513291, stageFp: 7.683178, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
        { stageQ: 0.557758, stageFp: 7.873187, stageFz: 1, stageId: 3, orderType: 2, gain: 1 },
        { stageQ: 0.65213, stageFp: 8.218579, stageFz: 1, stageId: 4, orderType: 2, gain: 1 },
        { stageQ: 0.858254, stageFp: 8.781055, stageFz: 1, stageId: 5, orderType: 2, gain: 1 },
        { stageQ: 1.506143, stageFp: 9.728848, stageFz: 1, stageId: 6, orderType: 2, gain: 1 },
      ],
    },
    {
      nthOrder: 12,
      stages: [
        { stageQ: 0.502756, stageFp: 8.298907, stageFz: 1, stageId: 1, orderType: 2, gain: 1 },
        { stageQ: 0.525936, stageFp: 8.412108, stageFz: 1, stageId: 2, orderType: 2, gain: 1 },
        { stageQ: 0.579367, stageFp: 8.650615, stageFz: 1, stageId: 3, orderType: 2, gain: 1 },
        { stageQ: 0.684008, stageFp: 9.043961, stageFz: 1, stageId: 4, orderType: 2, gain: 1 },
        { stageQ: 0.905947, stageFp: 9.656868, stageFz: 1, stageId: 5, orderType: 2, gain: 1 },
        { stageQ: 1.594657, stageFp: 10.66195, stageFz: 1, stageId: 6, orderType: 2, gain: 1 },
      ],
    },
  ],
});
